<div #pdfContent class="pdf-content" *ngIf="orderDetails">
  <div class="order-left">
    <div class="section">
      <div class="section-header">
        {{ orderDetails.orderDisplayId }}
      </div>
      <div class="label">
        {{ 'orders.orderInfo.checkId' | translate }}
      </div>
      <div class="data">
        {{ orderDetails.checkId }}
      </div>
      <div class="label" *ngIf="orderDetails.orderProcessingStatus.toUpperCase() === 'SCHEDULED'">
        {{ 'orders.orderInfo.scheduledFor' | translate }}
      </div>
      <div class="data" *ngIf="orderDetails.orderProcessingStatus.toUpperCase() === 'SCHEDULED'">
        {{ orderDetails.scheduledFor }}
      </div>
      <div class="label">
        {{ 'orders.orderInfo.serviceType' | translate }}
      </div>
      <div class="data">
        {{ 'brand.settings.serviceTypes.' + orderDetails.serviceType | translate }}
      </div>
      <div class="label">
        {{ 'orders.orderInfo.orderDateTime' | translate }}
      </div>
      <div class="data">
        {{ orderDetails.orderDate }}
      </div>
      <div class="label">
        {{ 'orders.orderInfo.readyDateTime' | translate }}
      </div>
      <div class="data">
        {{ orderDetails.estimatedTime }}
      </div>
      <div class="label" *ngIf="orderDetails?.metaData?.deviceType">
        {{ 'orders.orderInfo.deviceType' | translate }}
      </div>
      <div class="data" *ngIf="orderDetails?.metaData?.deviceType">
        {{ translateDeviceType(orderDetails.metaData.deviceType) }}
      </div>
      <div class="label">
        {{ 'orders.orderInfo.channelName' | translate }}
      </div>
      <div class="data">
        {{ orderDetails?.channelName }}
      </div>
      <div class="label" *ngIf="orderDetails?.metaData?.orderingChannel">
        {{ 'orders.orderInfo.subChannel' | translate }}
      </div>
      <div class="data" *ngIf="orderDetails?.metaData?.orderingChannel">
        {{ translateOrderingChannel(orderDetails.metaData.orderingChannel) }}
      </div>
    </div>

    <div class="section">
      <div class="section-header">
        {{ 'orders.orderInfo.items' | translate }}
      </div>

      <div class="items">
        <ng-template #itemRecursion let-items="items" let-top="top">
          <div [ngClass]="{ item: top, 'nested-item': !top }" *ngFor="let item of items">
            <div class="item-container">
              <div class="description">
                {{ item.quantity }} x
                {{ item?.description }}
                <txp-badge *ngIf="item.hidden" [type]="badgeType.NEW">
                  {{ 'orders.orderInfo.modifierHidden' | translate }}
                </txp-badge>
              </div>
              <div class="value">
                {{ item?.price | number: '1.2' }}
              </div>
            </div>
            <div *ngIf="item?.instructions" class="label instructions">
              {{ 'orders.orderInfo.note' | translate }} {{ item?.instructions || '---' }}
            </div>
            <ng-template
              [ngTemplateOutlet]="itemRecursion"
              [ngTemplateOutletContext]="{ items: item?.items }"
            >
            </ng-template>
          </div>
        </ng-template>

        <ng-template
          [ngTemplateOutlet]="itemRecursion"
          [ngTemplateOutletContext]="{ items: orderDetails.items, top: true }"
        >
        </ng-template>
      </div>

      <div class="label">
        {{ 'orders.orderInfo.deliveryInstructions' | translate }}
      </div>

      <div class="data">
        {{ orderDetails.deliveryInstructions || '---' }}
      </div>

      <div class="label">
        {{ 'orders.orderInfo.orderInstructions' | translate }}
      </div>

      <div class="data">
        {{ orderDetails.orderInstructions || '---' }}
      </div>
    </div>
  </div>
  <div class="order-right">
    <div class="section">
      <div class="section-header">
        {{ 'orders.orderInfo.totals' | translate }}
      </div>

      <div class="subtotal">
        <div class="description">
          {{ 'orders.orderInfo.subtotal' | translate }}
        </div>
        <div class="value">
          {{ orderDetails?.subtotal | number:'1.2' }}
        </div>
      </div>
      <div class="tax">
        <div class="description">
          {{ 'orders.orderInfo.tax' | translate }}
        </div>
        <div class="value">
          {{ orderDetails?.tax | number:'1.2' }}
        </div>
      </div>
      <ng-container *ngIf="orderDetails?.channelName === 'CONSUMER-API'">
        <ng-container *ngIf="orderDetails?.tips?.length; else legacyTip">
          <div class="tip-group" *ngFor="let tip of orderDetails.tips">
            <div class="tip">
              <div class="description">
                {{ 'orders.orderInfo.tip' | translate }}
                <txp-badge [type]="tip.type === 'Delivery' ? badgeType.PRIMARY : badgeType.INFO">
                  {{ 'orders.orderInfo.tipTypes.' + tip.type | translate }}
                </txp-badge>
              </div>
              <div class="value">
                {{ tip.amount | number: '1.2' }}
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #legacyTip>
          <div class="tip">
            <div class="description">
              {{ 'orders.orderInfo.tip' | translate }}
            </div>
            <div class="value">
              {{ orderDetails?.tip || '0' | number: '1.2' }}
            </div>
          </div>
        </ng-template>
      </ng-container>
      <div class="total">
        <div class="description">
          {{ 'orders.orderInfo.total' | translate }}
        </div>
        <div class="value">
          {{ orderDetails?.channelTotal  ? ('brand.businessInfo.' + currency | translate ) : '' }} {{ orderDetails?.channelTotal | number:'1.2' }}
        </div>
      </div>
    </div>

    <div class="section">
      <div class="section-header">
        {{ 'orders.orderInfo.customer' | translate }}
      </div>
      <div class="label">
        {{ 'orders.orderInfo.customerName' | translate }}
      </div>
      <div class="data">
        {{  orderDetails.user?.firstName ? (orderDetails.user.firstName) + ' ' + (orderDetails?.user?.lastName || '') : ('orders.orderInfo.notAvailable' | translate) }}
      </div>
      <div class="label">
        {{ 'orders.orderInfo.customerPhone' | translate }}
      </div>
      <div class="data">
        {{ orderDetails?.user.phone || ('orders.orderInfo.notAvailable' | translate)  }}
      </div>
      <div class="label" *ngIf="orderDetails?.user?.email">
        {{ 'orders.orderInfo.customerEmail' | translate }}
      </div>
      <div class="data" *ngIf="orderDetails?.user?.email">
        {{ orderDetails?.user?.email }}
      </div>
    </div>

    <div class="delivery-details" *ngIf="orderDetails.deliveryDetails">
      <div class="section-header">
        {{ 'orders.orderInfo.deliveryDetails' | translate }}
      </div>

      <div class="label">
        {{ 'orders.orderInfo.driverName' | translate }}
      </div>

      <div class="data">
        {{ orderDetails?.deliveryDetails?.driverName || '---' }}
      </div>

      <div class="label">
        {{ 'orders.orderInfo.deliveryProvider' | translate }}
      </div>

      <div class="data">
        {{ orderDetails?.deliveryDetails?.deliveryProvider || '---' }}
      </div>

      <div class="label">
        {{ 'orders.orderInfo.latitude' | translate }}
      </div>

      <div class="data">
        {{ orderDetails?.deliveryDetails?.latitude || '---' }}
      </div>

      <div class="label">
        {{ 'orders.orderInfo.message' | translate }}
      </div>

      <div class="data">
        {{ orderDetails?.deliveryDetails?.message || '---' }}
      </div>

      <div class="label">
        {{ 'orders.orderInfo.trackingUrl' | translate }}
      </div>

      <div class="data">
        {{ orderDetails?.deliveryDetails?.trackingUrl || '---' }}
      </div>

      <div class="label">
        {{ 'orders.orderInfo.dropoffEta' | translate }}
      </div>

      <div class="data">
        {{ orderDetails?.deliveryDetails?.dropoffEta || '---' }}
      </div>

      <div class="label">
        {{ 'orders.orderInfo.vehicleName' | translate }}
      </div>

      <div class="data">
        {{ orderDetails?.deliveryDetails?.vehicleName || '---' }}
      </div>

      <div class="label">
        {{ 'orders.orderInfo.vehicleType' | translate }}
      </div>

      <div class="data">
        {{ orderDetails?.deliveryDetails?.vehicleType || '---' }}
      </div>

      <div class="label">
        {{ 'orders.orderInfo.longitude' | translate }}
      </div>

      <div class="data">
        {{ orderDetails?.deliveryDetails?.longitude || '---' }}
      </div>
    </div>
  </div>
</div>
